
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo et description */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-green-500 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">F</span>
              </div>
              <span className="text-xl font-bold">FEEL</span>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              La plateforme de prévention santé qui vous accompagne pour agir dès aujourd'hui 
              et éviter les maladies de demain.
            </p>
            <div className="text-sm text-gray-400">
              <p className="font-medium mb-2">Sources scientifiques officielles :</p>
              <ul className="space-y-1">
                <li>• Organisation Mondiale de la Santé (OMS)</li>
                <li>• Haute Autorité de Santé (HAS)</li>
                <li>• Institut National du Cancer (INCa)</li>
              </ul>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="font-semibold mb-4">Navigation</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-gray-300 hover:text-white transition-colors">Accueil</Link></li>
              <li><Link to="/evaluation" className="text-gray-300 hover:text-white transition-colors">Évaluation</Link></li>
              <li><Link to="/resultats" className="text-gray-300 hover:text-white transition-colors">Ma prévention</Link></li>
              <li><Link to="/offres" className="text-gray-300 hover:text-white transition-colors">Nos offres</Link></li>
              <li><Link to="/a-propos" className="text-gray-300 hover:text-white transition-colors">À propos</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold mb-4">Contact</h3>
            <div className="space-y-2 text-sm text-gray-300">
              <p>hello@feel-prevention.com</p>
              <p>01 23 45 67 89</p>
              <p>123 rue de la Santé<br />75000 Paris</p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-400">
            © {currentYear} FEEL. Tous droits réservés.
          </p>
          <div className="flex space-x-6 text-sm text-gray-400 mt-4 md:mt-0">
            <Link to="/a-propos" className="hover:text-white transition-colors">Mentions légales</Link>
            <a href="#" className="hover:text-white transition-colors">Politique de confidentialité</a>
            <a href="#" className="hover:text-white transition-colors">CGU</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
